import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { categories } from "@/mocks/categories";
import { webtoons } from "@/mocks/webtoons";

export default function CategoryOverview() {
  useEffect(() => { document.title = "免费韩漫热门分类 · 漫糖韩漫"; }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <section className="bg-foreground-950">
        <div className="mx-auto max-w-7xl px-4 pb-10 pt-24 md:px-6 md:pt-28">
          <nav aria-label="面包屑" className="flex items-center gap-1.5 text-xs text-background-400">
            <Link to="/" className="hover:text-background-100">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-background-200">热门分类</span>
          </nav>
          <div className="mt-4">
            <span className="flex items-center gap-1.5 text-sm font-medium text-primary-400">
              <i className="ri-grid-fill"></i>
              免费韩漫热门分类
            </span>
            <h1 className="mt-2 font-heading text-3xl text-background-50 md:text-5xl">按题材,轻松找到对味的作品</h1>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-300">
              甜宠、奇幻、剧情、悬疑、校园、恋爱、热血、治愈八大分类全收录,每个分类都整理了高分榜单与人气推荐。
            </p>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-10 md:px-6">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-4">
          {categories.map((c) => {
            const count = webtoons.filter((w) => w.category === c.slug).length;
            return (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="group flex flex-col rounded-3xl border border-background-200/70 bg-background-100 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
              >
                <div className="flex items-center justify-between">
                  <span className={`flex h-12 w-12 items-center justify-center rounded-2xl text-background-50 ${c.color}`}>
                    <i className={`${c.icon} text-xl`}></i>
                  </span>
                  <span className="rounded-full bg-background-200 px-2.5 py-1 text-xs text-foreground-600">
                    {count}部作品
                  </span>
                </div>
                <h2 className="mt-5 text-xl font-bold text-foreground-950">{c.name}</h2>
                <p className="text-xs text-foreground-500">{c.en}</p>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
                <span className="mt-4 flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                  进入分类 <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </Link>
            );
          })}
        </div>
      </section>

      <Footer />
    </div>
  );
}